var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { "pointer-events-none": _vm.disabled } }, [
    _c("input", {
      ref: "input",
      staticClass: "w-full rounded-lg transition",
      class: [`size-${_vm.size} bg-${_vm.bgColor} textalign-${_vm.textalign}`],
      attrs: {
        type: _vm.type,
        disabled: _vm.disabled,
        minlength: _vm.minlength,
        maxlength: _vm.maxlength,
        placeholder: _vm.placeholder,
      },
      domProps: { value: _vm.value },
      on: {
        input: _vm.onInput,
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            )
              return null
            return _vm.onEvent.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.onEvent.apply(null, arguments)
          },
        ],
        focusout: _vm.onFocusout,
      },
    }),
    _vm.helpText
      ? _c(
          "p",
          {
            staticClass: "text-sm text-gray-400 select-none",
            class: _vm.helpTextColor,
          },
          [_vm._v(_vm._s(_vm.helpText))]
        )
      : _vm._e(),
    _vm.checkList.length > 0
      ? _c(
          "ul",
          { staticClass: "mt-1 p-1.5 flex flex-col gap-y-2" },
          _vm._l(_vm.checkList, function (checkItem, checkItemIndex) {
            return _c(
              "li",
              { key: checkItemIndex },
              [
                _c(
                  "GrmCheckbox",
                  {
                    attrs: { disabled: "", id: checkItemIndex },
                    model: {
                      value: checkItem.checked,
                      callback: function ($$v) {
                        _vm.$set(checkItem, "checked", $$v)
                      },
                      expression: "checkItem.checked",
                    },
                  },
                  [_vm._v(_vm._s(checkItem.text))]
                ),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }